<template>
  <v-window v-model="tab">
    <v-window-item>
      <list
          ref="tab0"
          :open-tab="openTab"/>
    </v-window-item>
    <v-window-item>
      <detail
          ref="tab1"
          :open-tab="openTab"
          :item="schedule"/>
    </v-window-item>
    <v-window-item>
      <create-or-update
          ref="tab2"
          :open-tab="openTab"
          :item="schedule"/>
    </v-window-item>
  </v-window>
</template>

<script>
import Detail from "./Detail";
import CreateOrUpdate from "./CreateOrUpdate";
import List from "./List";

export default {
  name: "GroupMain",
  components: {CreateOrUpdate, Detail, List},
  data() {
    return {
      schedule: null,
      tab: 0
    }
  },
  methods: {
    openTab(tab, schedule) {
      this.tab = tab
      this.schedule = schedule
      let t = this.$refs[`tab${tab}`]
      if (t) return t.onTab(this.schedule)
    }
  }
}
</script>

<style scoped>

</style>